import {ucFirst} from '@teemill/utilities';

export default {
  /**
   * Ensure the correct url format for blog requests
   *
   * @param  { Store }    state The Vuex store for blog
   * @return { String }        The url to fetch blogs from
   */
  nextPageUrl: state =>
    state.nextPageUrl
      ? state.nextPageUrl.replace(/\?page=([^&]+)/, '/?page=$1')
      : null,

  /**
   * Ensure the correct url format for blog requests
   *
   * @param  { Store } state The Vuex store for blog
   * @return { Route } route The vue router route
   */
  findActiveTag: state => route => {
    if (state.tagsPosts && state.tagsPosts.length) {
      return state.tagsPosts.find(tag => tag.code === route.params.tag) || null;
    }

    return null;
  },

  /**
   * Find tags by code in the state
   *
   * @param { Store }  state The Vuex store for blog
   * @param { String } tag   The string to search by
   */
  tagsPosts: state => tag => state.tagsPosts.find(t => t.code === tag),

  /**
   * Return a formatted list of tags that can be used by
   * TmlList
   *
   * @param { Store }  state The Vuex store for blog
   */
  listTags: state =>
    state.tags.map(tag => ({
      text: `#${tag.name}`,
      href: tag.url,
    })),

  /**
   * Search posts for a certain url title
   *
   * @param { Store }  state      The Vuex store for blog
   * @param { String } urlTitle   The urlTitle to search by
   */
  statePost: state => urlTitle =>
    [...state.posts].find(t => t.urlTitle === urlTitle),

  /**
   * Return an array of the current post's tags for seo
   *
   * @param { Store }   state           The Vuex store for blog
   * @param { String }  identifier      The keyword prefix
   */
  seoKeywords: state => identifier =>
    state.post ? state.post.tags.map(tag => `${identifier}:${tag.name}`) : [],

  /**
   * Get a formatted document title to apply to the page
   *
   * @param { Store }    state          The Vuex store for blog
   * @param { Object }   route          Vue route instance
   * @param { String }   suffix         String to append to title
   */
  pageTitle: state => route => {
    switch (route.name) {
      case 'blog-post':
        return state.post ? ucFirst(state.post.title) : '';

      case 'blog-tag':
        return state.tag ? ucFirst(state.tag.name) : '';

      case 'blog.dashboard':
        return 'Learn';

      default:
        return 'Learn';
    }
  },
};
